<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Configuration-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.configuration') }}</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Role-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.roles') }}</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Role-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.permission') }}</h3>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'User-group-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.userGroup') }}</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Amenities-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.amenity') }}</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Source-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.source') }}</h3>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";

export default {
    page: {
        title: i18n.t("module.other"),
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: i18n.t("module.other"),
            items: [
                {
                    text: i18n.t("module.other"),
                    active: true,
                },
            ],
        }
    }
}
</script>
